import { DEVICE_READY_PATHS } from "./config";

export default ({ location }) =>
  DEVICE_READY_PATHS.find(drp => location.pathname.indexOf(drp) === 0) !==
  undefined;
